import React, { ReactNode, Fragment } from "react";
import { Popover as HeadlessPopover, Transition } from "@headlessui/react";

type PopoverProps = {
  items?: ReactNode[];
  children?: ReactNode;
  containerClassName?: string;
  itemClassName?: string;
  disabled?: boolean;
  open?: boolean;
};

export const Popover = ({
  items,
  children,
  containerClassName,
  itemClassName,
  disabled,
}: PopoverProps) => {
  return (
    <HeadlessPopover as="div" className="relative">
      <HeadlessPopover.Button as="div">{children}</HeadlessPopover.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="opacity-0 translate-y-1"
        enterTo="opacity-100 translate-y-0"
        leave="transition ease-in duration-150"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-1"
      >
        <HeadlessPopover.Panel className="overflow-hidden absolute left-1 z-10 px-4 sm:px-0 mt-2 max-w-xs transform -translate-x-1/2">
          <div
            className={
              containerClassName ||
              "flex flex-col bg-transparent shadow-lg rounded-md ring-1 ring-black ring-opacity-5 focus:outline-none"
            }
          >
            {items?.map((item, index) => (
              <div
                key={index}
                className={
                  itemClassName ||
                  "bg-transparent p-2 rounded-md hover:bg-gray-300 "
                }
              >
                {item}
              </div>
            ))}
          </div>
        </HeadlessPopover.Panel>
      </Transition>
    </HeadlessPopover>
  );
};

export default Popover;
